<script>
import TwModal from '../generic/modal/tw-modal.vue'
import TwSelect from '../generic/forms/tw-select.vue'
import modalCascadeMixin from '../../mixins/modalCascadeMixin.js'
import { useFundraiserPageStore } from '../../stores/fundraiserPage.js'
import { useFundraiserPagePublicStore } from '../../stores/fundraiserPagePublic.js'
import loggedInUserMixin from '../../mixins/loggedInUserMixin.js'
import TwLoadingSpinner from '../generic/tw-loading-spinner.vue'
import TwCard from '../generic/tw-card.vue'

export default {
  name: 'FundraiserTeamJoinModal',
  components: { TwCard, TwLoadingSpinner, TwSelect, TwModal },
  mixins:[modalCascadeMixin, loggedInUserMixin],
  props: {
    team: {
      type: Object,
      required: true
    },
    fundraiser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      UserFundraiserPages: [],
      SelectedFundraiserPage: null,
      Loading: false,
      LoadingFetchingFundraiserPages: false,
    }
  },
  methods: {
    async joinTeamWithSelectedFundraiserPage() {
      if(!confirm(`Join the team ${this.team.name} with fundraiser ${this.SelectedFundraiserPage.title}?`)) {
        return;
      }
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        await useFundraiserPageStore().setTeamForFundraiserPage({team_id: this.team.id, fundraiser_page_id: this.SelectedFundraiserPage.id})
        this.Loading = false
        this.$notify(`Successfully joined the team <strong>${this.team.name}</strong> with fundraiser <strong>${this.SelectedFundraiserPage.title}</strong>`)
        await this.close()
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async fetchUserFundraiserPages() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingFundraiserPages = true
        const results = await useFundraiserPageStore().fetchItems()
        if(results.data) {
          this.UserFundraiserPages = results.data.filter(item => item.owner_user_id === this.loggedInUser.id && item.fundraiser_id === this.team.fundraiser_id)
        }
        this.LoadingFetchingFundraiserPages = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingFundraiserPages = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" :ok-disabled="Loading || !SelectedFundraiserPage" title="Select which fundraiser you want to join this team with:" :loading="LoadingFetchingFundraiserPages || Loading" @opened="fetchUserFundraiserPages" @ok="joinTeamWithSelectedFundraiserPage">
    <tw-loading-spinner v-if="LoadingFetchingFundraiserPages" />
    <div v-else>
      <tw-card v-if="fundraiser.settings.teams_message" class="bg-gray-50 mb-3">
        <div v-html="fundraiser.settings.teams_message" />
      </tw-card>
      <tw-select v-if="UserFundraiserPages.length > 0" v-model="SelectedFundraiserPage" label-key="title" :options="UserFundraiserPages" />
      <div v-else>
        You don't have any fundraisers yet, please join a campaign first.
      </div>
    </div>
  </tw-modal>
</template>

<style scoped>

</style>
